import { Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine } from 'core/elements';
import { ISalesHistoryItem } from 'parts/types';

export const LocationCell = ({ data, value }: ICellRendererParams<ISalesHistoryItem>) => {
  if (!data) {
    return value;
  }

  return (
    <Stack>
      <TextLine text={data.salesLocationName || DEFAULT_PLACEHOLDER} />
      <TextLine text={data.salesLocation || DEFAULT_PLACEHOLDER} isSubText />
    </Stack>
  );
};
